module.exports = __webpack_public_path__ + "static/listen-on-apple-podcast-73e9586637bc3c66a109a02ff0e941cc.svg";